/*
* Created on Jan 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {forwardRef, useState} from 'react';
import ic_admin_d_layer_svg from '../../static/img/content/ic-admin-d-layer.svg'
import ic_util_more_svg from '../../static/img/utils/ic-util-more.svg'
import ic_util_sys_info from '../../static/img/utils/ic_sys_info_outline_white.svg'
import { useNavigate } from '../../hook/NavigateHook'
import MainContentSummaryRowGroupComponent from "./MainContentSummaryRowGroupComponent";
import MainContentSummaryRowSiteComponent from "./MainContentSummaryRowSiteComponent";
import useToggle from "../../hook/ToggleHook";
import OrganizationEditModelComponent from "./Organization/OrganizationEditModelComponent";
import ModalAlertComponent from "../common/ModalComonent/ModalAlertComponent";
import OrganizationDeleteModalComponent from "./Organization/OrganizationDeleteModalComponent";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import MainContentSummaryRowDeviceComponent from "./MainContentSummaryRowDeviceComponent";
import {useRegion} from "../../context/RegionContext";
import MainContentSummaryRowAdminComponent from "./MainContentSummaryRowAdminComponent";
import BadgeGroup from "./BadgeGroup";


const MainContentSummaryRowComponent = forwardRef((props, ref) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const organization = props.organization;
    const {goAccountList, goGroups, goSites, goDevice, goSettings} = useNavigate(organization);
    const [open, node] = useToggle();
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openLeaveAlert, setOpenLeaveAlert] = useState(false);
    const [defaultLeaveWarning, setDefaultLeaveWarning] = useState('@You will no longer have access to any QNAP services or data within this organization. Your Personal Space, if present, will be transferred to the Organization Owner and only visible to them. If you currently pay for the license subscriptions, leaving will not cancel them automatically. Please manually unsubscribe and notify your organization owner to reassign licenses if needed.@');
    const {url} = useRegion();

    const onCloseLeaveAlert = (close) => {
        setDefaultLeaveWarning('@You will no longer have access to any QNAP services or data within this organization. Your Personal Space, if present, will be transferred to the Organization Owner and only visible to them. If you currently pay for the license subscriptions, leaving will not cancel them automatically. Please manually unsubscribe and notify your organization owner to reassign licenses if needed.@');
        setOpenLeaveAlert(close);
    }

    const role = organization.current_user?.role;
    const cuPerms = organization.current_user?.permissions || {};
    const canManageUsers = role === 'owner' || role === 'user_manager' || 'manage_user' in cuPerms;

    const onGoGroupClick = (e) => {
        if (!canManageUsers) {
            goSettings(e);
            return;
        }
        goGroups(e);
    }
    const onGoAccountListClick = (e) => {
        if (!canManageUsers) {
            goSettings(e);
            return;
        }
        goAccountList(e);
    }

    const onGoSiteClick = (e) => {
        goSites(e);
    }

    const onGoDeviceClick= (e) => {
        const permissions = organization.current_user?.permissions || {};
        const manage_device = permissions?.manage_device || {};
        const fixed_devices = Object.values(manage_device?.fixed || [])?.reduce((acc, cur) => acc + cur.length, 0);
        const total_device = (manage_device?.user_assigned || [])?.length + fixed_devices;
        if (role !== 'owner' && role !== 'user_manager' && total_device <= 0) {
            goSettings(e);
            return;
        }
        goDevice(e);
    }

    const leaveOrganization = async (alert, setSimpleButton) => {
        try {
            await OrganizationAPI.delete(`organization/${organization.organization_id}/user/${currentUser.user_id}`)
            // props.setOrgList((prevList=>{
            //     return prevList.filter(org=>org.organization_id !== organization.organization_id);
            // }));
            // props.setOrgCount(prevCount=> prevCount+1);
            props.doRefreshHeaderOrgList(prevCount => prevCount+1);
            setOpenLeaveAlert(false);
        } catch (e) {
            setSimpleButton(true);
            setDefaultLeaveWarning('@Last one to leave organization warning message@')
        }
        // show global message is needed.
    }

    const userStatus = organization.user_counts || {};
    const oldest = organization.oldest_owner || {};
    const is_owner = organization.current_user?.is_owner === true;

    return (
        <div ref={ref} className={`summary-row ${organization.new ? 'new-created' : ''} ${organization.default ? 'default-org': ''}`}>
            <BadgeGroup organization={organization} />
            <div className="summary-row-content">
                <div className="col-head">
                    <div className="owner-wrapper">
                        <div className="owner">
                            <span className="text">{t('@Owner@')}</span>
                            <div className="user-tag user-tag-tiny">
                            <span className="tag-account-img">
                              {oldest?.has_avatar ?
                                  <span className="tag-avatar"><img src={`${url.get_acc_url()}/avatar/${oldest.id}/i`} alt={''}/></span> :
                                  <span className="tag-avatar no-avatar"><span>{oldest?.display_name?.[0]}</span></span>
                              }
                            </span>
                                <span className="tag-account-id">{oldest?.id===currentUser?.user_id ? t('@Me@') : oldest?.email}</span>
                            </div>
                        </div>
                    </div>
                    <div className={`avatar ${organization.avatars ? '' : 'no-avatar'}`} onClick={onGoGroupClick}>
                        { organization.avatars ? <img src={`${organization.avatars.small}?t=${new Date().getTime()}`} alt=""/> : <span>{organization.name[0]}</span> }
                    </div>
                    <div className="org-name" onClick={onGoGroupClick}>{organization.name}</div>
                </div>
                <div className="col-divide" />
                <MainContentSummaryRowAdminComponent organization={organization} userStatus={userStatus} goAccountList={onGoAccountListClick} />
                <div className="col-divide" />
                <MainContentSummaryRowGroupComponent organization={organization} goGroups={onGoGroupClick} />
                <div className="col-divide" />
                <MainContentSummaryRowSiteComponent organization={organization} goSites={onGoSiteClick} />
                <div className="col-divide" />
                <MainContentSummaryRowDeviceComponent organization={organization} goDevice={onGoDeviceClick}/>
                <div className="col-act">
                    <div className="util-btn" ref={node}>
                        <img src={ic_util_more_svg} alt=""/>
                        <div className={`comp-dropdown ${open==='show' ? '' : 'hide'}`}>
                            <ul className="comp-dropdown-menu">
                                <li className="section">
                                    {organization.current_user?.is_owner && <div className="section-items selection" onClick={()=>setOpenEditModal(true)}>{t('@Edit@')}</div>}
                                    <div className="section-items selection" onClick={()=>setOpenLeaveAlert(true)}>{t('@Leave@')}</div>
                                    {!organization.default && organization.current_user?.is_owner && <div className="section-items selection" onClick={()=>setOpenDeleteModal(true)}>{t('@Remove@')}</div>}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                {openEditModal && <OrganizationEditModelComponent openModal={openEditModal} closeModal={()=>setOpenEditModal(false)} organization={organization} setOrgList={props.setOrgList}/>}
                {openDeleteModal && <OrganizationDeleteModalComponent openModal={openDeleteModal} closeModal={()=>setOpenDeleteModal(false)} organization={organization} />}
                {openLeaveAlert &&
                <ModalAlertComponent isOpen={openLeaveAlert} onClose={onCloseLeaveAlert} onConfirmAction={async (_alert, _setButton)=> await leaveOrganization(_alert, _setButton)} externalAlert={true}>
                    <div className="alert-msg-inner-head">{t('@Leave this organization?@')}</div>
                    <div>{t(defaultLeaveWarning)}</div>
                </ModalAlertComponent>}
            </div>
            {
                    organization.description &&
                    <div className="summary-row-description">
                        <div className="summary-row-description__inner">
                            <div className="summary-row-description__inner__wrapper">
                                <div className="summary-row-description__inner__wrapper__label">{t('@Description@')}:</div>
                                <div className="summary-row-description__inner__wrapper__text">
                                    {organization.description}
                                </div>
                            </div>
                        </div>
                    </div>
                }
        </div>
    );
});

export default MainContentSummaryRowComponent;